import type { ElementModels } from "@kontent-ai/delivery-sdk";

export function getIcon(type?: ElementModels.MultipleChoiceOption) {
    if (type) {
        switch (type.codename) {
            case 'pdf':
            case 'excel':
            case 'word':
                return `file-${type.codename}`;
            default:
                return 'square-arrow-up-right';
        }
    }

    return '';
}